module.exports = __webpack_public_path__ + "c82957b61fde508cc8a4c86a4417afb2.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/wasistgoldencity3.jpg
// module id = 503
// module chunks = 0